<template>
    <CModal title="Trả lời phản ánh kiến nghị" :show.sync="isShowPopup">
        <CRow class="content-fade-in">
          <CCol md="12">
                <CForm class="form-basic">
                  <CRow>
                    <CCol sm="12" md="12" xl="12">
                      <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data" v-model="descriptionInput.data.model"/>
                    </CCol>
                    <CCol sm="12" md="12" xl="12">
                      <div class="form-input-wrapper">
                        <div class="form-group">
                            <label class="form-label" for="uploadFile">Chọn tệp đính kèm</label>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="uploadFile" ref="file" @change="selectFile($event)">
                                <label class="custom-file-label" for="uploadFile">{{ fileName }}</label>
                            </div>
                        </div>
                      </div>
                    </CCol>
                  </CRow>
                  <BaseLoading :loading="loading.value"></BaseLoading>
                </CForm>
          </CCol>
        </CRow>

        <template v-slot:footer>
            <div slot="footer">

                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="isShowPopup = false"
                    ><i class="fa fa-close"></i> Hủy bỏ
                </button>&nbsp;

                <button
                    type="button"
                    class="btn btn-primary"
                    @click="submitData()"
                    >
                    <i class="fa fa-reply"></i> Trả lời
                </button
                >
            
            </div>
        </template>
    </CModal>
</template>
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";

export default {
  props: ["actionTypeMapping"],
  components: {BaseInput, BaseSelect, BaseLoading, BaseTextArea},
  data() {
    var that = this;
    return {
      isShowPopup: false,
      actionTypeKey: '',
      fileName: 'Chọn tệp',
      loading: {value: false},

      descriptionInput: {
        options: {
          label: "Nội dung trả lời <span class='required'>*</span>",
          placeholder: "Nội dung trả lời",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.descriptionInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nội dung trả lời không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      idField: {
        data: {
          model: -1,
          name: "id"
        }
      },

      selectedFiles: {
        data: {
          name: "file",
          model: {
            fileName: '',
            content: ''
          }
        }
      },
      
    };
    
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      var actionType = this.actionType;
      var _successCallback = actionType.successCallback;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/residents-feedback/responseFeedback",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          that.isShowPopup = false;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else if(_successCallback){
            _successCallback(response.data);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.isShowPopup = false;
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      var file = this.$refs.file.files[0];
      that.fileName = file.name;
      reader.readAsDataURL(file);
      reader.onload = function() {
        setTimeout(function(){
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.content = reader.result.split(',')[1];
        }, 500)
      }
    },
    setCurrAction: function(key) {
      this.actionTypeKey = key;
    },
    setIdField: function(id) {
      this.idField.data.model = id;
    },
    clearData: function(){
      let that = this;
      // that.$helper.setupDataResponse(that.$data, {});
      that.selectedFiles.data.model = {};
      that.fileName = 'Chọn tệp';
      that.descriptionInput.data.model = "";
    }
  },
  created() {
    
  },
  mounted() {
  },
  updated() {

  },
  computed: {
    actionType: function() {
      return this.actionTypeMapping.get(this.actionTypeKey);
    }
  },
  watch: {
   actionTypeKey: function(newValue) {
     if(newValue) {
       this.isShowPopup = true;
     }
   },
   isShowPopup: function(newValue) {
     if(!newValue) {
       this.actionTypeKey = null;
     }
   }
  }
};
</script>
<style scoped></style>